import { c as _c } from "react/compiler-runtime";
export const BlogImageSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative w-full aspect-video overflow-hidden rounded-md bg-muted animate-pulse" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};